"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@mui/material/utils");
var SvgRealEnergy = (0, utils_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, {}, react_1.default.createElement("path", { d: "M18.652 4.64 21 2.294v1.414l-1.64 1.64-.708-.706ZM8.607 11.012H4v-8h4.607v1.39h-2.91V6.16h2.708v1.39H5.696v2.063h2.911v1.4ZM19 16l3 3-3 3v-2H4v-2h15v-2ZM21 12.011v3h-1v-3h1ZM21 9.998v-3h-1v3h1ZM14.41 10.298l-2.121 2.121-.707-.707 2.12-2.121.708.707ZM15.824 8.883l2.122-2.12-.708-.708-2.12 2.121.706.707ZM7.286 16.008H8.7l2.175-2.175-.708-.707-2.881 2.882Z" })), 'SvgRealEnergy');
exports.default = SvgRealEnergy;
